import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const feeAdjustmentClauseFilterLabel = () => t({ message: 'Fee Adjustment Clause', comment: 'Insights: Fee Adjustment Clause filter' });
export function FeeAdjustmentClauseFilter() {
    return <BooleanFilter name="metadataDocumentFeeAdjustmentClause" label={feeAdjustmentClauseFilterLabel()}/>;
}
